import { defineMessages } from 'react-intl';

export default defineMessages({
	title: {
		id: 'dev-agents.credit-request.title',
		defaultMessage: 'Out of Rovo credits',
		description: 'Heading when Code Reviewer is blocked by Rovo credits.',
	},
	description: {
		id: 'dev-agents.credit-request.description',
		defaultMessage: 'Code Reviewer can’t review your pull request.',
		description: 'Explanation of why the GitHub review could not run.',
	},
	reset: {
		id: 'dev-agents.credit-request.reset',
		defaultMessage: 'Resets {resetDate, date, long}.',
		description: 'Date when the Rovo credit limit resets.',
	},
	request: {
		id: 'dev-agents.credit-request.request',
		defaultMessage: 'Request credits',
		description: 'Action to request additional Rovo credits from organization admins.',
	},
	confirmation: {
		id: 'dev-agents.credit-request.confirmation',
		defaultMessage:
			'Your request will be sent to your organization admins in a daily email. They may receive it within 24 hours.',
		description: 'Explanation shown before the user confirms an email credit request.',
	},
	redirectConfirmation: {
		id: 'dev-agents.credit-request.redirectConfirmation',
		defaultMessage: 'Request more credits through your organization’s process.',
		description: 'Explanation of an organization-managed credit request link.',
	},
	cancel: {
		id: 'dev-agents.credit-request.cancel',
		defaultMessage: 'Cancel',
		description: 'Dismiss the confirmation without sending a credit request.',
	},
	sent: {
		id: 'dev-agents.credit-request.sent',
		defaultMessage: 'Request sent',
		description: 'Heading after the credit request has been accepted.',
	},
	sentDescription: {
		id: 'dev-agents.credit-request.sentDescription',
		defaultMessage:
			"A request for extra credits has been sent to your administrator(s). We'll notify you if extra usage is enabled.",
		description:
			'Confirmation that the request was sent and the user will be notified if extra usage is enabled.',
	},
	rateLimited: {
		id: 'dev-agents.credit-request.rateLimited',
		defaultMessage: 'You’ve requested credits recently. Try again later.',
		description: 'Error shown when requests are rate limited until Retry-After expires.',
	},
	failed: {
		id: 'dev-agents.credit-request.failed',
		defaultMessage: 'We couldn’t send your request. Try again.',
		description: 'Error allowing an explicit retry after an unsuccessful credit request.',
	},
	lookupFailed: {
		id: 'dev-agents.credit-request.lookupFailed',
		defaultMessage: 'We couldn’t check your credits. Try again.',
		description: 'Error after a failed credit-state lookup.',
	},
	retry: {
		id: 'dev-agents.credit-request.retry',
		defaultMessage: 'Try again',
		description: 'Retry checking the current credit state.',
	},
	unavailable: {
		id: 'dev-agents.credit-request.unavailable',
		defaultMessage: 'Credit requests aren’t available',
		description: 'Heading when the user cannot request credits on this site.',
	},
	unavailableDescription: {
		id: 'dev-agents.credit-request.unavailableDescription',
		defaultMessage:
			'You can’t request more Rovo credits here. Contact your organization admins for help.',
		description: 'Explanation for a user who cannot request more credits.',
	},
	available: {
		id: 'dev-agents.credit-request.available',
		defaultMessage: 'Rovo credits are available',
		description: 'Heading when preflight no longer reports a credit denial.',
	},
	availableDescription: {
		id: 'dev-agents.credit-request.availableDescription',
		defaultMessage: 'Return to GitHub to request another review.',
		description: 'Instruction when the user is no longer blocked by credits.',
	},
	back: {
		id: 'dev-agents.credit-request.back',
		defaultMessage: 'Back to GitHub',
		description: 'Navigation back to GitHub after the credit request flow.',
	},
	loading: {
		id: 'dev-agents.credit-request.loading',
		defaultMessage: 'Checking your credits',
		description: 'Accessible label for the credit state loading spinner.',
	},
});
